import type { IframePoolShippingDetail } from '../../../modules/api';

type Props = {
  shipping: IframePoolShippingDetail;
  isCancelWindowClosed: boolean;
};

const NOTE_CLASS = 'm-0 text-[14px] leading-[20px] text-[var(--co-ShipCard-mutedText,#6D707C)]';
const WARNING_CLASS = 'm-0 text-[14px] leading-[20px] text-[var(--co-ShippingItemStatus-refundedFg,#FFB020)]';

/** What the status chip can't say: tracking once shipped, the cards the
 *  warehouse couldn't ship (refunded), a cancel attempt that came too late. */
export function ShipmentStatusNote({ shipping, isCancelWindowClosed }: Props) {
  const refunded = shipping.items.filter((item) => item.settleStatus === 'unavailable');
  return (
    <>
      {shipping.trackingNumber && (
        <p className={NOTE_CLASS}>
          Tracking: {[shipping.companyName, shipping.trackingNumber].filter(Boolean).join(' ')}
        </p>
      )}
      {refunded.length > 0 && (
        <p className={WARNING_CLASS}>
          We couldn't ship {refunded.map((item) => item.title).join(', ')}. The card was refunded to your balance.
        </p>
      )}
      {isCancelWindowClosed && (
        <p role="alert" className={WARNING_CLASS}>
          This delivery can no longer be canceled — it is already being prepared for shipment.
        </p>
      )}
    </>
  );
}
